import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ProtracksLevels from './ProtracksLevels'

import './styles.scss'

const baseClass = 'on-boarding-select-protrack'

class OnBoardingSelectProTrack extends Component {
  static propTypes = {
    getIdentityProgress: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.props.getIdentityProgress()
  }

  render() {
    return (
      <div className={baseClass}>
        <ProtracksLevels />
      </div>
    )
  }
}

export default OnBoardingSelectProTrack
